import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { WHO_USES_LIST } from '#src/app/pages/about/main/shared/consts';
import { EmbeddedVideo } from '#src/app/shared/components/embeddedMedia';

import { WhoUsesCard } from './components/WhoUsesCard';

export const WhoUses: React.FC<EmptyProps> = () => {
	return (
		<div className="container">
			<div className="py-8">
				<EmbeddedVideo
					aspectRatio="16/9"
					embedHtml='<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/FMyDni0SGxw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
				/>
				<Text as="h2" variant="heading" size="large" className="mt-8 font-normal">
					<Translate value="fe.pages.about.description" />
				</Text>
				<Text as="h3" variant="heading" className="text-typography-weak mt-8 font-bold uppercase" size="xx-small">
					<Translate value="fe.pages.about.section_users.header" />
				</Text>
				<div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
					{WHO_USES_LIST.map((card) => (
						<WhoUsesCard key={card.icon} {...card} />
					))}
				</div>
			</div>
		</div>
	);
};
